import * as angular from 'angular';
import { StudentCreditGapsPanelProgressComponent } from './student-credit-gaps-panel-progress.component';

export const StudentCreditGapsPanelProgressModule = angular
  .module('studentCreditGapsPanelProgress', [])
  .component('studentCreditGapsPanelProgress', StudentCreditGapsPanelProgressComponent).name;
